import AreaForm from "@/components/areas/AreaForm";
import Header from "@/components/Header";
import { useSiteName } from "@/hooks/useSiteName";
import { ValidationError } from "@/lib/http-client";
import type { LayoutContext } from "@/lib/models";
import { Area, AreaService } from "@/services/AreaService";
import { useEffect, useState } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router";

const AreaCreatePage: React.FC = () => {
  const params = useParams();
  const { siteName } = useSiteName(params.siteId);
  const [newArea, setNewArea] = useState<Area | null>(null);
  const { setPageName } = useOutletContext<LayoutContext>();
  const navigate = useNavigate();

  useEffect(() => {
    setNewArea({description: "", id: "", name: "", siteId: params.siteId!});
  }, [params.siteId]);

  useEffect(() => {
    setPageName(`Site: ${siteName} Create Area`);
  }, [siteName, setPageName]);

  const onSubmit = async (formData: Omit<Area, "id">) => {
    if (!params.siteId) {
      alert('error invalid siteId')
      return null
    }

    const updatedArea: Area = {
      id: params.areaId!,
      ...formData,
    };

    try {
        const area = await AreaService.create(updatedArea);
        navigate(`/sites/${params.siteId}/area/${area.id}`);
    } catch (error) {
        if (error instanceof ValidationError) {
            return error.errors;
        }
    }
    return null;
  };

  return (
    <div className="container mx-auto p-4">
      <Header headerTitle={`Site: ${siteName}`} />
      <AreaForm onSubmit={onSubmit} initialData={newArea as Area} />
    </div>
  );
};

export default AreaCreatePage;
